import { makeSvgIcon } from '../makeSvgIcon'

export const square = makeSvgIcon(<rect x="3" y="3" width="18" height="18" />)
